import MisFortalezasLayer from "../../components/MisFortalezasLayer";

const MisFortalezasPage = () => {
  return <MisFortalezasLayer />;
};

export default MisFortalezasPage;
